import { Reveal } from "@components/ui";

const certifications = [
  {
    badge: "DCD",
    title: "DCD Approved",
    subtitle: "Dubai Corporation for Ambulance Services",
    color: "#f03813",
  },
  {
    badge: "ESMA",
    title: "ESMA Certified",
    subtitle: "Emirates Authority for Standardization",
    color: "#122d63",
  },
  {
    badge: "14001",
    title: "ISO 14001",
    subtitle: "Environmental Management System",
    color: "#1a7a4f",
  },
  {
    badge: "45001",
    title: "ISO 45001",
    subtitle: "Occupational Health & Safety",
    color: "#6b4fc7",
  },
];

const ComplianceCertsSection = () => {
  return (
    <section className="py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        <Reveal>
          <div className="flex flex-col items-center text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#f03813]/10 text-[#f03813] text-[14px] md:text-[16px] font-medium tracking-[-0.04em] mb-4">
              Compliance
            </span>
            <h2 className="text-[28px] md:text-[44px] lg:text-[60px] tracking-[-0.04em] font-semibold text-[#122d63]">
              Safety & Environmental Compliance
            </h2>
            <p className="text-[20px] md:text-[24px] lg:text-[28px] text-[#62636c] tracking-[-0.04em] mt-3 max-w-[700px]">
              Meeting and exceeding industry standards
            </p>
            <p className="text-[16px] md:text-[18px] text-[#62636c] tracking-[-0.04em] mt-5 max-w-[860px] leading-relaxed">
              GAZ operates under strict regulatory oversight from Dubai
              Corporation for Ambulance Services (DCD) and Emirates Authority
              for Standardization and Metrology (ESMA), maintaining full
              compliance with international safety and environmental standards.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {certifications.map((cert, index) => (
            <Reveal key={index} className="h-full">
              <div className="group rounded-[24px] border border-[rgba(98,99,108,0.2)] bg-white p-6 hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] hover:border-[#e8e9ed] transition-all duration-300 h-full flex flex-col items-center text-center">
                {/* Badge circle */}
                <div
                  className="w-20 h-20 rounded-full flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300"
                  style={{
                    backgroundColor: `${cert.color}15`,
                    color: cert.color,
                  }}
                >
                  <span className="text-[18px] font-bold tracking-[-0.02em]">
                    {cert.badge}
                  </span>
                </div>

                <h3 className="text-[20px] md:text-[24px] font-semibold text-[#090d2c] tracking-[-0.04em] mb-2">
                  {cert.title}
                </h3>
                <p className="text-[14px] md:text-[16px] text-[#62636c] tracking-[-0.04em]">
                  {cert.subtitle}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComplianceCertsSection;
